import { Button, Tooltip } from 'antd';
import Icon, {
  DeleteOutlined,
  HomeOutlined,
  MinusOutlined,
  PlusOutlined,
} from '@ant-design/icons';
import { useUnit } from 'effector-react';
import { useTranslation } from 'react-i18next';
import style from './MapNavControls.module.css';
import { mapCenterPC } from '../../utils/mapbox-utils.js';
import { $activeCity, $showMetric } from '../../models/logicModel/index.js';
import { city_centers } from '../../dictionaries/city_centers.js';
import {
  changeDrawModeEv,
  changeInteractivityEv,
} from '../../models/mapModel/index.js';
import { deleteAll } from '../../utils/draw_polygon_utils.js';

function PolygonSvg() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <line
        x1="19.001"
        y1="7"
        x2="19.001"
        y2="17"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <line
        x1="4.97266"
        y1="7"
        x2="4.97266"
        y2="17"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <line
        x1="17"
        y1="5.2998"
        x2="7"
        y2="5.2998"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <line
        x1="17"
        y1="19.0205"
        x2="7"
        y2="19.0205"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <circle cx="19" cy="5" r="2" stroke="currentColor" strokeWidth="1.5" />
      <circle cx="5" cy="5" r="2" stroke="currentColor" strokeWidth="1.5" />
      <circle cx="5" cy="19" r="2" stroke="currentColor" strokeWidth="1.5" />
      <circle cx="19" cy="19" r="2" stroke="currentColor" strokeWidth="1.5" />
    </svg>
  );
}

function PolygonIcon() {
  return <Icon component={PolygonSvg} />;
}

function MapNavControls() {
  const showMetric = useUnit($showMetric);
  const activeCity = useUnit($activeCity);
  const changeDrawMode = useUnit(changeDrawModeEv);
  const changeInteractivity = useUnit(changeInteractivityEv);
  const { t } = useTranslation();

  const onDrawClick = () => {
    changeDrawMode('draw_polygon');
    changeInteractivity(false);
    window.draw.changeMode('draw_polygon');
  };

  const zoomHandle = (isIn) => {
    if (isIn) {
      window.map.flyTo({
        zoom: window.map.getZoom() + 1,
      });
    } else {
      window.map.flyTo({
        zoom: window.map.getZoom() - 1,
      });
    }
  };

  const zoomHome = () => {
    window.map.flyTo({
      center: city_centers[activeCity],
      zoom: 10,
    });
  };

  return (
    <div
      className={[
        style.map_nav_controls,
        showMetric ? style.moved : style.initial,
      ].join(' ')}
    >
      <div className={style.controls_wrapper}>
        <Tooltip title={t('zoom_in')} placement="right">
          <Button
            onClick={() => zoomHandle(true)}
            icon={<PlusOutlined className={style.button_icon} />}
            className={[style.button, 'glass'].join(' ')}
          />
        </Tooltip>
        <Tooltip title={t('zoom_out')} placement="right">
          <Button
            onClick={() => zoomHandle(false)}
            icon={<MinusOutlined className={style.button_icon} />}
            className={[style.button, 'glass'].join(' ')}
          />
        </Tooltip>
        <Tooltip title={t('return')} placement="right">
          <Button
            onClick={zoomHome}
            icon={<HomeOutlined className={style.button_icon} />}
            className={[style.button, 'glass'].join(' ')}
          />
        </Tooltip>
        <Tooltip title={t('select_zone')} placement="right">
          <Button
            onClick={() => onDrawClick('draw_polygon')}
            icon={<PolygonIcon className={style.button_icon} />}
            className={[style.button, 'glass'].join(' ')}
          />
        </Tooltip>
        <Tooltip title={t('delete_zone')} placement="right">
          <Button
            onClick={deleteAll}
            icon={<DeleteOutlined className={style.button_icon} />}
            className={[style.button, 'glass'].join(' ')}
          />
        </Tooltip>
      </div>
    </div>
  );
}

export default MapNavControls;
